import { defineLatticeConfig } from '@noven-prime/lattice-core';
/**
 * Lattice configuration for the Denise Augusta site.
 *
 * A single web surface with two experiences: the public marketing site and
 * the Entra ID-protected admin area mounted at /admin.
 */
export const latticeConfig = defineLatticeConfig({
    app: {
        id: 'denise-augusta',
        version: '0.0.1',
    },
    scopes: {
        hierarchy: ['root', 'admin', 'user'],
        relationships: {
            root: ['admin'],
            admin: ['user'],
        },
    },
    surfaces: {
        web: {
            name: 'Web Application',
            description: 'Browser-based public site and admin interface',
        },
    },
    experiences: {
        admin: {
            name: 'Administrator',
            description: 'Site administration — content editing and media management',
            defaultScopes: ['root', 'admin'],
        },
        public: {
            name: 'Public',
            description: 'Public visitor access',
            defaultScopes: ['user'],
        },
    },
    capabilities: {},
});
//# sourceMappingURL=lattice.config.js.map